var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3149 22.9831H19.6167C19.6167 14.3155 12.5656 7.26439 3.89816 7.26439V3.56616C14.6044 3.56616 23.3149 12.2767 23.3149 22.9831ZM3.89818 20.2058C3.89818 18.674 5.14016 17.432 6.672 17.432C8.20384 17.432 9.44581 18.674 9.44581 20.2058C9.44581 21.7377 8.20384 22.9797 6.672 22.9797C5.14016 22.9797 3.89818 21.7377 3.89818 20.2058ZM13.1447 22.9821H16.8429C16.8429 15.8443 11.0359 10.0373 3.89818 10.0373V13.7362C8.99645 13.7362 13.1447 17.8838 13.1447 22.9821Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRss);
export default __webpack_public_path__ + "static/media/rss.65ffed0112b768e9f6f7153deb9a37bd.svg";
export { ForwardRef as ReactComponent };